<script setup>
import { onMounted, ref } from 'vue'
import { useAppStore } from '~/stores/app'
import logoTwoImg from '~/assets/images/logo2.png'

const emit = defineEmits(['open-nav'])
const store = useAppStore()
const userFirstName = ref('')

const fetchUserFirstName = () => {
  const raw = localStorage.getItem('user')
  if (!raw) return
  const user = JSON.parse(raw)
  if (user?.first_name) userFirstName.value = user.first_name
}

const logout = () => {
  setTimeout(() => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    store.logout()
    window.location.href = '/login'
  }, 1000)
}

onMounted(() => {
  fetchUserFirstName()
})
</script>

<template>
  <header class="layout-navbar">
    <div class="navbar-content-container lp-container">
      <div class="navbar-left">
        <AppIconButton
          class="nav-toggle"
          size="sm"
          aria-label="Open menu"
          @click="emit('open-nav')"
        >
          <AppIcon name="hero-bars-3" size="lg" />
        </AppIconButton>

        <NuxtLink class="navbar-brand" to="/home" aria-label="Automatisera Mera">
          <img class="navbar-brand__logo" :src="logoTwoImg" alt="Automatisera Mera" />
          <span class="navbar-brand__label">Automatisera Mera</span>
        </NuxtLink>
      </div>

      <div class="navbar-actions">
        <div class="lp-body" aria-label="Inloggad användare">
          {{ userFirstName }}
        </div>

        <details class="navbar-menu">
          <summary
            class="navbar-menu__toggle app-icon-btn app-icon-btn--sm"
            aria-label="User menu"
          >
            <AppIcon name="hero-user-circle" size="lg" />
          </summary>

          <div class="navbar-menu__panel" role="menu">
            <button class="navbar-menu__item" type="button" role="menuitem" @click="logout">
              <AppIcon name="hero-arrow-left-on-rectangle" size="md" />
              Logga ut
            </button>
          </div>
        </details>
      </div>
    </div>
  </header>
</template>
